/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/
import React from 'react';
import { motion, cubicBezier } from 'framer-motion';
import { UsersIcon } from '../components/icons';
import { useTranslation } from '../i18n/useTranslation';

const GuestAccessDeniedPage: React.FC = () => {
    const { t } = useTranslation();

    const sectionVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: cubicBezier(0.42, 0, 0.58, 1) } },
    };

    return (
        <motion.div
            initial="hidden"
            animate="visible"
            variants={sectionVariants}
            className="flex-grow flex flex-col items-center justify-center p-4 sm:p-8 bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-200"
        >
            <div className="max-w-md w-full bg-white dark:bg-gray-800 shadow-lg rounded-xl p-6 md:p-10 text-center border border-gray-200 dark:border-gray-700">
                <UsersIcon className="w-12 h-12 text-indigo-500 mx-auto mb-4" />
                <h1 className="text-3xl font-serif font-bold text-gray-900 dark:text-white mb-4">
                    {t('guestAccess_title')}
                </h1>
                <p className="text-gray-600 dark:text-gray-400">
                    {t('guestAccess_message')}
                </p>
            </div>
        </motion.div>
    );
};

export default GuestAccessDeniedPage;
